<template>
    <div>
        <!-- Breadcrumb Section Start -->
        <section class="breadscrumb-section pt-0">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-12">
                        <div class="breadscrumb-contain">
                            <h2>{{ $t('My Favorites') }}</h2>
                            <nav>
                                <ol class="breadcrumb mb-0">

                                    <!--                                    <li class="breadcrumb-item active" aria-current="page">-->
                                    <!--                                        Shop Right Sidebar-->
                                    <!--                                    </li>-->

                                    <li class="breadcrumb-item">
                                        <router-link :to="{name: 'home', params: { lang : $i18n.locale }}" >
                                            <i class="fa-solid fa-house"></i>
                                        </router-link>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Breadcrumb Section End -->

        <!-- Shop Section Start -->
        <section class="section-b-space shop-section">
            <div class="container-fluid-lg">
                <div class="row">
                    <div class="col-custome-12 wow fadeInUp">
                        <div class="show-button">

                            <div class="top-filter-menu mt-0 w-100  d-flex  justify-content-between">
                                <div class="category-dropdown">
                                    <h5 class="text-content text-content pt-1">{{ $t('Sort by') }} :</h5>
                                    <div class="dropdown">
                                        <select class="form-select" aria-label="" v-model="q.order">
                                            <option :value="null" selected>
                                                {{ $t('Featured') }}
                                            </option>
                                            <option :value="{'by' : 'price' , 'direction' : 'DESC' , }">
                                                {{ $t('Price high to low') }}
                                            </option>
                                            <option :value="{'by' : 'price' , 'direction' : 'ASC' , }">
                                                {{ $t('Price low to high') }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="filter-button-group mt-0">
                                    <div class="filter-button d-inline-block d-lg-none">
                                        <a>
                                            <i class="fa-solid fa-filter"></i>
                                            <!--                                            {{ $t('Filter Menu')}}-->
                                        </a>
                                    </div>
                                </div>

                                <div class="grid-option d-none d-md-block">
                                    <ul>
                                        <li class="three-grid">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/grid-3.svg" class="blur-up lazyload" alt="">
                                            </a>
                                        </li>
                                        <li class="grid-btn d-xxl-inline-block d-none active">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/grid-4.svg"
                                                     class="blur-up lazyload d-lg-inline-block d-none" alt="">
                                                <img src="/theme/assets/svg/grid.svg"
                                                     class="blur-up lazyload img-fluid d-lg-none d-inline-block" alt="">
                                            </a>
                                        </li>
                                        <li class="list-btn">
                                            <a href="javascript:void(0)">
                                                <img src="/theme/assets/svg/list.svg" class="blur-up lazyload" alt="">
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div
                            class="row g-sm-4 g-3 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 product-list-section">
                            <div v-for="product in items?.data" :key="product.id" >
                                <div class="product-box-3 h-100 wow fadeInUp">
                                    <div class="product-header">
                                        <div class="product-image">
                                            <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <img :src="product.image ?? '/theme/assets/images/more/product-card.png'"
                                                     class="img-fluid blur-up lazyload" alt="">
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="product-footer">
                                        <div class="product-detail">

                                            <router-link :to="{name: 'products.show', params: { id: product.id , lang : $i18n.locale  }}">
                                                <h5 class="name  mb-2"> {{ product?.name }} </h5>
                                            </router-link>
                                            <p class="text-content mt-1 mb-2 product-content">
                                                {{ product?.description}}
                                            </p>
                                            <div class="d-flex justify-content-end"
                                                v-if="product?.prices?.length === 0">
                                                <h5 class="price">

                                                    <del class="text-content" v-if="product?.old_price != null">{{ product?.old_price }} {{ $t('priceSymbol') }}</del>

                                                    <span class="theme-color">{{ product?.price_tax }} {{ $t('priceSymbol') }}</span>


                                                    <!--                                                    <span class="offer theme-color" v-if="product?.discount !== null">({{ product?.discount }}% تخفيض)</span>-->

                                                </h5>
                                            </div>
                                            <CartButton :product="product" :type="'box'"></CartButton>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <Bootstrap5Pagination
                            class="m-2"
                            :data="items"
                            :limit="2"
                            :show-disabled="false"
                            :size="'default'"
                            :align="'center'"
                            @pagination-change-page="pagination"
                        />

                    </div>
                </div>
            </div>
        </section>
        <!-- Shop Section End -->
    </div>
</template>

<script>

import { useToast } from "vue-toastification";
const toast = useToast();
import Utility from "../../utility";

import { Bootstrap5Pagination } from 'laravel-vue-pagination'
import CartButton from "../cart_item/CartButton.vue";
export default {
    props: ['main'],
    components:{
        CartButton,
        Bootstrap5Pagination
    },
    watch: {
        'q': { // Auto search
            handler: function(newValue) {

                let form_params = Utility.convertModelToFormData(newValue);
                // if(this.isCreated == true){
                //     form_params.append('page', 1);
                // }

                this.$router.replace({
                    name: "products.favorite",
                    query: Object.fromEntries(form_params) , params: { lang : this.$i18n.locale }
                });

                console.log('---handler');
                // this.getResults(1,'filter');
            },
            deep: true
        },
        // '$route.query': { // Auto search
        //     handler: function(newValue,oldValue) {
        //         if(oldValue.page==newValue.page){
        //             this.getResults(1,'query');
        //         }
        //     },
        //     deep: true
        // }
    },
    data() {
        return {
            // isCreated: false,
            // getResultsOnCreate: true,
            debounceTimer: null,
            items: [],
            q_price: {
                from : null,
                to : null
            },
            q: {
                order : null,
                price : {
                    from : null,
                    to : null
                },
                section_ids : [],
                category_ids : [],
                vendor_ids : [],
                quantities : {
                    from : null,
                    to : null
                },
                ...this.$route.query,
            },
            form_options: {},
        }
    },
    async created() {
        // this.isCreated = true;
        console.log('---created');
        // console.log(this.$route?.query);
        // console.log(this.$route?.query?.length);
        //
        // const numberOfQueryKeys = Object.keys(this.$route?.query || {}).length;
        // console.log(numberOfQueryKeys);

        this.removeArrayQueries(this.q);

        // if(this.getResultsOnCreate){
        await this.getResults(this.$route?.query?.page ?? 1 ,'query');
        // }

        await this.themeJs();
    },
    methods: {
        removeArrayQueries(dataObject) {
            // const that = this;
            // Function to remove array-based query parameters from the 'q' data object
            // console.log('removeArrayQueries');
            for (const key in dataObject) {
                const matches = key.match(/(\w+)\[(\d*)\]/);

                if (
                    matches !== null
                ) {

                    const new_key = matches[1];
                    // console.log(new_key);
                    // console.log(typeof dataObject[key]);

                    // push new value  to dataObject[new_key] or create new if not exists and push
                    if (Array.isArray(dataObject[new_key])) {
                        dataObject[new_key].push(dataObject[key]);
                        // this.getResultsOnCreate = false;
                    } else {
                        dataObject[new_key] = [dataObject[key]];
                        // this.getResultsOnCreate = false;
                    }
                    delete dataObject[key];
                }
            }
            return dataObject;
        },
        setName(val) {
            this.q.name = val;
        },
        themeJs() {

            (function ($) {
                "use strict";

                /*=====================
                02. Shop Page Grid Setting Js
                ==========================*/
                $(".grid-option li").on("click", function () {
                    $(this).addClass('active').siblings().removeClass('active');
                });
                $(".grid-option .grid-btn").on("click", function () {
                    $(".product-list-section").removeClass("list-style");
                });
                $(".grid-option .list-btn").on("click", function () {
                    $(".product-list-section").addClass("list-style");
                });
                $('.three-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.grid-btn').on('click', function (e) {
                    $(".product-list-section").removeClass("row-cols-xxl-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2 list-style").addClass("row-cols-xxl-4 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                $('.five-grid').on('click', function (e) {
                    $(".product-list-section").removeClass("list-style").addClass("row-cols-xxl-5 row-cols-xl-3 row-cols-lg-2 row-cols-md-3 row-cols-2");
                });
                var contentwidth = $(window).width();
                if (contentwidth < "1199") {
                    $(".grid-options ul .grid-btn").addClass("active");
                }
                if (contentwidth < "1399") {
                    $(".grid-options ul .three-grid").addClass("active");
                }
            })(jQuery);

            /**=====================
             Filter Sidebar js
             ==========================**/
            $(".filter-button").click(function () {
                console.log('---- filter-button');
                $(".bg-overlay, .left-box").addClass("show");
            });
            $(".back-button, .bg-overlay").click(function () {
                $(".bg-overlay, .left-box").removeClass("show");
            });

            $(document).ready(function () {
                $(".sort-by-button").click(function () {
                    $(".top-filter-menu").toggleClass("show");
                });
            });
        },
        onPriceInput() {
            // Clear the previous timer if exists
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            // Set up a new timer to call the handler after 500ms (adjust the time as needed)
            this.debounceTimer = setTimeout(() => {

                // Perform actions or update the filter based on the provided values
                // For example, you can emit an event to notify the parent component of the changes.
                this.q.price = {
                    'from' : this.q_price.from,
                    'to' : this.q_price.to,
                };
            }, 500); // Adjust the delay time (in milliseconds) as needed
        },
        async pagination(page) {

            let form_params = Utility.convertModelToFormData(this.q);
            form_params.append('page', page);
            this.$router.replace({
                name: "products.favorite",
                query: Object.fromEntries(form_params) , params: { lang : this.$i18n.locale }
            });

        },
        async getResults(page,type = 'filter') {
            console.log(page);
            console.log('getResults <---');

            const id = toast.info(this.$t('Getting content ...'), {icon: 'fa-light fa-filter-list'});
            let _params = null;
            console.log(type);
            if(type == 'query'){
                _params = {
                    ...this.$route.query,
                    page: page,
                };
            }else{
                _params = {
                    ...this.q,
                    page: page,
                };
            }
            let form_params = Utility.convertModelToFormData(this.q);
            await axios.get('products/favorite', {params: Object.fromEntries( form_params )}).then(response => {
                toast.dismiss(id);
                this.items = response.data;

            }, response => {
                toast.dismiss(id);
            });

        },
    },
}
</script>
